// panel-styles.service.ts
import { Injectable, inject, computed, signal, effect } from '@angular/core';
import { HeightService } from '../height/height.service';

@Injectable({ providedIn: 'root' })
export class PanelStylesService {
  private heightService = inject(HeightService);

  private allStyles = signal<Record<number, string[]>>({
    32: ['32S'],
    39: ['39S'],
    52: ['52S', '52G'],
    65: ['65S', '65G', '65DG']
  });

  readonly availableStyles = computed(() => {
    const height = this.heightService.selectedHeight();
    return height ? this.allStyles()[height] ?? [] : [];
  });

  private manualStyle = signal<string | null>(null);

  readonly selectedStyle = computed(() => {
    const manual = this.manualStyle();
    if (manual) return manual;

    const available = this.availableStyles();
    return available.length > 0 ? available[0] : null;
  });

  constructor() {
    // Reset manual style whenever height changes → ensures fallback to default
    effect(() => {
      this.heightService.selectedHeight();
      this.manualStyle.set(null);
    });
  }

  setSelectedStyle(style: string): void {
    this.manualStyle.set(style);
  }
}
